import {SSLAConfiguration} from "../config";
import {Manifest} from "./manifest";
import {AllScosData} from "./sco";
import * as mathier from "../mathier";
import * as Message from "../message";


type ScoWeighting = {[key: string]: number};


export function rollupScores(allScos:AllScosData, config:SSLAConfiguration, manifest:Manifest, scoreType:string):string {
    if (scoreType != "raw" && scoreType != "normalized") {
        throw new Error("rollupScores, scoreType must be one of 'raw', 'normalized'.");
    }
    if (config.scoreRollupCustomFunction()) {
        return config.scoreRollupCustomFunction()(allScos, config, manifest, scoreType);
    }

    if (config.scoreRollupAction() == "last") {
        let scoWeights: ScoWeighting = {};
        scoWeights[manifest.navigableScoPreOrderTraversal[manifest.navigableScoPreOrderTraversal.length - 1].identifier] = 1.0;
        return rollupScoreByScoWeightedSelection(allScos, config, manifest, scoWeights, scoreType);
    }

    if (config.scoreRollupAction() == "first") {
        let scoWeights: ScoWeighting = {};
        scoWeights[manifest.navigableScoPreOrderTraversal[0].identifier] = 1.0;
        return rollupScoreByScoWeightedSelection(allScos, config, manifest, scoWeights, scoreType);
    }

    if (config.scoreRollupAction() == "all_equal" || config.scoreRollupAction() == "") {
        return rollupScoreBasic(allScos, config, manifest, scoreType);
    }

    Message.show(this.config, Message.Error,"Unknown score rollup type: " + config.scoreRollupAction());
    return "";
}

function rollupScoreBasic(allScos:AllScosData, config:SSLAConfiguration, manifest:Manifest, scoreType:string):string {
    let rollupScore: number = 0;
    let tempScore: string = "";
    let contributingScos: number = 0;
    for (let i=0; i < manifest.scoPreOrderTraversal.length; i++) {
        if (manifest.scoPreOrderTraversal[i].isLeaf) {
            let k = manifest.scoPreOrderTraversal[i].identifier;
            if (allScos.scos.hasOwnProperty(k)) {
                if (scoreType == "raw") {
                    tempScore = allScos.scos[k].getRawScore(config.scoreConvertNormalizedToRawMethod());
                } else if (scoreType == "normalized") {
                    tempScore = allScos.scos[k].getNormalizedScore(config.scoreConvertRawToNormalizedMethod());
                }
                if (tempScore !== "") {
                    rollupScore += Number(tempScore);
                    contributingScos += 1;
                } else if (config.scoreRollupIncludeScosWithNoScore()) {
                    contributingScos += 1;
                }
            }
        }
    }

    if (contributingScos == 0) {
        return "";
    }
    return "" + mathier.round(rollupScore / contributingScos, 3);
}

function rollupScoreByScoWeightedSelection(allScos:AllScosData, config:SSLAConfiguration, manifest:Manifest,
                                           includedScos:ScoWeighting, scoreType:string) {
    let rollupScore: number = 0;
    let tempScore: string = "";
    let contributingScos: number = 0;
    for (let i=0; i < manifest.scoPreOrderTraversal.length; i++) {
        if (manifest.scoPreOrderTraversal[i].isLeaf) {
            let k = manifest.scoPreOrderTraversal[i].identifier;
            // TODO This check may be redundant inside an isLeaf check.
            if (allScos.scos.hasOwnProperty(k)) {
                if (includedScos.hasOwnProperty(k)) {
                    if (scoreType == "raw") {
                        tempScore = allScos.scos[k].getRawScore(config.scoreConvertNormalizedToRawMethod());
                    }
                    else if (scoreType == "normalized") {
                        tempScore = allScos.scos[k].getNormalizedScore(config.scoreConvertRawToNormalizedMethod());
                    }
                    if (tempScore !== "") {
                        rollupScore += Number(tempScore) * includedScos[k];
                        contributingScos += 1;
                    }
                }
            }
        }
    }

    if (contributingScos == 0) {
        return "";
    }
    return "" + mathier.round(rollupScore / contributingScos, 3);
}
